export interface IFarmSettings {
    FarmGuid: string;
    SettingType: FarmSettingTypeEnum;
    SettingValue: number;
    ValidityStart: string;
    ValidityEnd?: string | null;
    CreationDate: string;
}

export interface IStoreFarmSettingsPayload {
    FarmGuid: string;
    SettingType: FarmSettingTypeEnum;
    SettingValue: number;
}

export interface IFarmSettingsUpdatePayload {
    FarmGuid: string;
    SettingType: FarmSettingTypeEnum;
    SettingValue: number;
    ValidityEnd?: string | null;
}

export enum FarmSettingTypeEnum {
    Unknown = 0,
    PreliminaryAnnouncementsInUse = 1,
}
